import { IConfigServiceInjectedProps, ConfigService } from '$State/ConfigFreezerService';
import { React } from '../../Imports';

interface IGeotabConfigurationProps {}

interface IGeotabConfigurationState {}

export class _GeotabConfiguration extends React.Component<
    IGeotabConfigurationProps & IConfigServiceInjectedProps,
    IGeotabConfigurationState
> {
    constructor(props: IConfigServiceInjectedProps) {
        super(props);
    }

    render() {
        const baseUrl = this.props.config.getBaseUrl();
        const geotabConfigObject: any = {
            name: 'VidLocate',
            supportEmail: 'gmautz@yaharasoftware.com',
            version: '1.0',
            items: [
                {
                    path: 'ActivityLink',
                    menuId: 'VidLocateLink',
                    menuName: {
                        en: 'Video Platform',
                    },
                },
                {
                    path: 'VidLocateLink/',
                    menuName: {
                        en: 'Video Events',
                    },
                    url: baseUrl + '/VideoEvents',
                },
                {
                    url: baseUrl + '/VideoRecall',
                    path: 'VidLocateLink/',
                    menuName: {
                        en: 'Video Recall',
                    },
                },
                {
                    path: 'VidLocateLink/',
                    menuId: 'ConfigurationLink',
                    menuName: {
                        en: 'Configuration',
                    },
                },
                {
                    url: baseUrl + '/Installers',
                    path: 'ConfigurationLink/',
                    menuName: {
                        en: 'Installers',
                    },
                },
                {
                    url: baseUrl + '/DeviceAssociations',
                    path: 'ConfigurationLink/',
                    menuName: {
                        en: 'Device Association',
                    },
                },
                {
                    url: baseUrl + '/Settings',
                    path: 'ConfigurationLink/',
                    menuName: {
                        en: 'Settings',
                    },
                },
                {
                    url: baseUrl + '/VideoDashboard',
                    path: 'VidLocateLink/',
                    menuName: {
                        en: 'Video Dashboard',
                    },
                },
            ],
            isSigned: false,
        };

        return <div>{JSON.stringify(geotabConfigObject)}</div>;
    }
}

export const GeotabConfiguration = ConfigService.inject(_GeotabConfiguration);
